import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import { BiSearch } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig"
import { FormParser } from "../Components";
import Modal from 'react-bootstrap/Modal';
import Masters from "../Components/masters.json";
import DataTable from 'react-data-table-component';
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { FaHandHoldingHeart } from "react-icons/fa";
import useDebouncedValue from "../Utils/Debounce";

const Discounts = () => {
    let today_date = (new Date()).toISOString().split('T')[0];
    const [search, SetSearch] = useState({
        search: ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
    }
    const MastersModal = Masters.Discount
    // const MastersModalEdit = Masters.DiscountEdit
    const [MastersModalEdit, setMastersModalEdit] = useState(JSON.parse(JSON.stringify(Masters.DiscountEdit)));
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
    const [Error, SetError] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("");
    const [Data, SetData] = useState([]);
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState()
    const [totalRows, setTotalRows] = useState(0);
    const [renderKey, setRenderKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [show, setShow] = useState(false);
    const [modalTitle, setModalTitle] = useState("Discounts");
    const [message, setMessage] = useState('')
    const [date, setDate] = useState({
        from_date: "",
        to_date: ""
    });
    const [formData, setFormData] = useState({
    });

    const handleShow = () => {
        setShow(true)
        // setSelectedImage("")
        setFormData({
        });
        setBlogid(null);
        setModalTitle("Discounts");
    };
    const handleClose = () => {
        setShow(false)
        // SetError("")
        setpopupType("")
    };
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/catlog/discount-coupons/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}&page_size=${RowPerPage}&coupon_end_date_after=${date.from_date}&coupon_end_date_before=${date.to_date}&fields_coupon=start_date,end_date,code,description,active,is_auto_apply,can_apply_with_other_coupons,user_redeem_limit,is_display_coupon,id`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const [passwordError, setPasswordError] = useState("");
    const formSubmit = (FormData, id) => {
        console.log(FormData, "formdata")
        let description = "";

        // Discount
        if (FormData?.discount_type === "fixed") {
            description = `Flat ₹${FormData.discount_amount} off on orders above ₹${FormData.minimum_purchase_amount}`;
        }

        if (FormData?.discount_type === "percentage") {
            description = `Get ${FormData.discount_percent}% off on orders above ₹${FormData.minimum_purchase_amount}`;
        }

        // IMPORTANT: check using final formData values
        if (FormData?.is_productorcategory_is_specific) {
            if (FormData?.product_id) {
                description += ` Offer applicable on ${FormData.product_id_name} only`;
            }
            else if (FormData?.category) {
                description += ` Offer applicable on ${FormData.category_name} only`;
            }
        }
        const isFutureDate = FormData?.end_date && new Date(FormData.end_date) > new Date();
        let formData = {
            active: FormData?.active,
            can_apply_with_other_coupons: FormData?.can_apply_with_other_coupons,
            category: FormData?.is_productorcategory_is_specific ? FormData?.category : null,
            code: FormData?.code.toUpperCase(),
            coupon: FormData?.coupon,
            description: description,
            discount_amount: FormData?.discount_amount ? FormData.discount_amount : null,
            discount_percent: FormData?.discount_percent ? FormData.discount_percent : null,
            discount_type: FormData?.discount_type,
            end_date: FormData?.end_date,
            id: FormData?.id,
            is_auto_apply: FormData?.is_auto_apply,
            is_display_coupon: FormData?.is_display_coupon,
            maximum_discount_amount: FormData?.maximum_discount_amount,
            minimum_purchase_amount: FormData?.minimum_purchase_amount,
            product_id: FormData?.is_productorcategory_is_specific ? FormData?.product_id : null,
            start_date: FormData?.start_date,
            is_applicable_inapp: FormData.is_applicable_inapp,
            user_redeem_limit: FormData?.user_redeem_limit ? FormData?.user_redeem_limit : null,
            user: FormData?.is_user_spesific ? FormData.user ? FormData.user : null : null,
            customer_type: FormData?.customer_type
        }
        if (new Date(formData.start_date) >= new Date(formData.end_date)) {
            setpopupType("error");
            setMessage("End date must be greater than start date.");
            return;
        }
        if (FormData.id) {
            axiosConfig.put(`/catlog/discount-coupons/${FormData.id}/`, formData)
                .then(res => {
                    console.log(res)
                    setpopupType("success")
                    setPasswordError("");
                    GetData();
                    setShow(false);
                    setMessage("Record Updated Successfully !")
                }).catch(error => {
                    setpopupType("error")
                    if (error.response.data?.error) {
                        setMessage(error.response.data?.error)
                    }
                })
        } else {
            axiosConfig.post("/catlog/discount-coupons/", formData).then(res => {
                console.log(res)
                setpopupType("success")
                setPasswordError("");
                GetData();
                setShow(false);
            }).catch(error => {
                console.log(error)
                setpopupType("error")
                if (error.response.data?.error) {
                    console.log(error.response.data?.error)
                    setMessage(error.response.data?.error)
                }
            })
        }
    };
    //     const isExpired = formData.end_date && new Date(formData.end_date) < new Date();

    // if (isExpired) {
    //     // Make end_date and active editable when expired
    //     MastersModalEdit.fields = MastersModalEdit.fields.map(field => {
    //         if (field.fieldName === 'end_date' || field.fieldName === 'active') {
    //             field.always_read_only = false;
    //         } else {
    //             field.always_read_only = true;
    //         }
    //         if (field.fieldType === 'group' && field.fields) {
    //             field.fields = field.fields.map(subField => {
    //                 subField.always_read_only = true;
    //                 return subField;
    //             });
    //         }
    //         return field;
    //     });
    // }
    useEffect(() => {
        const endDate = formData.end_date ? new Date(formData.end_date) : null;
        const isExpired = endDate && endDate < new Date();

        let updatedMastersModalEdit = JSON.parse(JSON.stringify(Masters.DiscountEdit));

        if (isExpired) {
            updatedMastersModalEdit.fields = updatedMastersModalEdit.fields.map(field => {
                if (field.fieldName === 'active' || field.fieldName === 'end_date') {
                    field.always_read_only = false;
                }
                return field;
            });
        } else {
            updatedMastersModalEdit.fields = updatedMastersModalEdit.fields.map(field => {
                if (field.fieldName !== 'end_date') {
                    field.always_read_only = true;
                } else {
                    field.always_read_only = false;
                }
                
                if (field.fieldType === 'group' && field.fields) {
                    field.fields = field.fields.map(subField => {
                        subField.always_read_only = true;
                        return subField;
                    });
                }
                return field;
            });
        }

        console.log("Updated MastersModalEdit:", updatedMastersModalEdit);
        setMastersModalEdit(updatedMastersModalEdit);
        setRenderKey(prev => prev + 1); // ADD THIS LINE
    }, [formData.end_date, formData.start_date]);
    const GetData = async () => {
        setLoading(true)
        try {
            const responce = await axiosConfig.get(`/catlog/discount-coupons/?page=${currentPage}&search=${debouncedSearchTerm}&page_size=${RowPerPage}&coupon_end_date_after=${date.from_date}&coupon_end_date_before=${date.to_date}&fields_coupon=start_date,end_date,code,description,active,is_auto_apply,can_apply_with_other_coupons,user_redeem_limit,is_display_coupon,id&fields_free_product_id=name,image&fields_discount_product_id=name,image`)
            SetData(responce.data.results)
            setLoading(false)
            setTotalRows(responce.data.count)
        }
        catch (error) {
            console.log(error)
        }

    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        setDate((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };
    function extractDate(timestamp) {
        const date = new Date(timestamp);

        // Extracting the date in 'YYYY-MM-DD' format based on local time
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    const tableCustomStyles = {
        table: {
            style: {
                backgroundColor: "#fff",
                borderRadius: "18px",
                overflow: "hidden",
                border: "1px solid #e8e8e8",
                margin: "10px 10px"
            },
        },

        headRow: {
            style: {
                minHeight: "68px",
                borderBottom: "1px solid #ececec",
                backgroundColor: "#fff",
            },
        },

        headCells: {
            style: {
                fontSize: "11px",
                fontWeight: "500",
                color: "#6b7280",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontFamily: "Inter, sans-serif",
                paddingLeft: "18px",
                paddingRight: "18px",
            },
        },

        rows: {
            style: {
                minHeight: "78px",
                borderBottom: "1px solid #f1f1f1",
                fontSize: "13px",
                fontWeight: 500,
                fontFamily: "Inter, sans-serif",
            },
        },

        cells: {
            style: {
                paddingLeft: "18px",
                paddingRight: "18px",
                whiteSpace: "normal",
                lineHeight: "15px",
            },
        },

        pagination: {
            style: {
                borderTop: "1px solid #ececec",
                minHeight: "60px",
            },
        },
    };
    useEffect(() => {
        GetData();
    }, [currentPage, RowPerPage, debouncedSearchTerm]);
    // Removed auto-activation logic as per user request to allow manual operation instead

    const [blogid, setBlogid] = useState()
    const blogedit = (id) => {
        axiosConfig.get(`/catlog/discount-coupons/${id}/?fields_coupon=start_date,end_date,code,description,active,is_auto_apply,can_apply_with_other_coupons,user_redeem_limit,is_display_coupon,id&fields_category=name,image,id&fields_product_id=name,image,id&fields_user=id,name,full_name`).then(res => {
            console.log(res.data, "edit")
            setFormData({
                user: res.data?.user?.id,
                user_name: res.data?.user?.full_name || res.data?.user?.name,
                id: res?.data?.id, "code": res.data?.coupon?.code,
                "description": res.data?.coupon?.description,
                "start_date": res.data?.coupon?.start_date,
                "end_date": res.data?.coupon?.end_date,
                "active": res.data?.coupon?.end_date && new Date(res.data?.coupon?.end_date) < new Date() ? false : res.data?.coupon?.active,
                "is_auto_apply": res.data?.coupon?.is_auto_apply,
                "can_apply_with_other_coupons": res.data?.coupon?.can_apply_with_other_coupons,
                "is_display_coupon": res.data?.coupon?.is_display_coupon,
                "user_redeem_limit": res.data?.coupon?.user_redeem_limit,
                "discount_percent": res.data?.discount_percent,
                "category": res.data?.category?.id,
                "category_name": res.data?.category?.name,
                "product_name": res.data?.product_id?.name,
                is_applicable_inapp: res.data.is_applicable_inapp,
                is_productorcategory_is_specific: res.data?.category?.id ? true : false,
                is_user_spesific: res.data?.user?.id ? true : false,
                customer_type: res.data?.customer_type,
                "discount_amount": res.data?.discount_amount, discount_type: res.data?.discount_type, "coupon": res.data?.coupon?.id, product_id: res.data?.product_id?.id, minimum_purchase_amount: res.data?.minimum_purchase_amount, maximum_discount_amount: res.data?.maximum_discount_amount
            })
            setBlogid(id)
            setShow(true)
        }).catch(error => {
            console.log(error)
        })
    }
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true,
            reorder: true,
        },
        {
            name: "Validity",
            selector: "active",
            cell: row => `${row.coupon?.start_date ? extractDate(row.coupon?.start_date) : "N/A"}-${row.coupon?.end_date ? extractDate(row.coupon?.end_date) : "N/A"}`,
            sortable: true,
            reorder: true,
        },
        {
            name: "code",
            cell: row => `${row.coupon?.code}`,
            sortable: true,
            reorder: true,
        },
        {
            name: "Configurations",
            cell: row => <>
                <div className="card-ma">
                    {row?.coupon?.active && <div class="client-type contract-background">Active</div>}
                    {row?.coupon?.is_auto_apply && <div class="client-type contract-background">Is Auto Apply</div>}
                    {row?.coupon?.can_apply_with_other_coupons && <div class="client-type contract-background">Can Apply With Other Coupons</div>}
                    {row?.coupon?.is_display_coupon && <div class="client-type contract-background">Is Display Coupon</div>}
                    {row?.is_applicable_inapp && <div class="client-type contract-background">Is Applicable In App</div>}
                </div>
            </>,
            sortable: true,
            reorder: true,
            style: {
                display: "flex",
                justifyContent: "start"

            },
        },
        {
            name: "Discount Percent",
            selector: "discount_percent",
            cell: row => row.discount_percent ? `${row.discount_percent}%` : 0,
            sortable: true,
            reorder: true,
        },
        {
            name: "Discount Amount",
            selector: "discount_amount",
            cell: row => row.discount_amount ? `${row.discount_amount}` : 0,
            sortable: true,
            reorder: true,
        },
        {
            name: "ACTIONS",
            reorder: true,
            width: "240px",
            selector: row => {
                const HandleEdit = async () => {
                    console.log(row.id, 'iddddd')
                    setShow(true)
                    blogedit(row.id)
                    handleShow(row.id);
                    setModalTitle("Edit Discounts");
                }
                const DeleteAlert = () => {
                    SetRowId(row.id)
                    SetAlertDeletePopupType("success")
                }
                const CancelAlerrt = () => {
                    SetAlertDeletePopupType("error")
                }
                const HandleDelete = async (id) => {
                    await axiosConfig.delete(`/catlog/discount-coupons/${id}/`).then(() => {
                        SetAlertDeletePopupType("error")
                        setDeletepopupType("success")
                        GetData();
                    }).catch((error) => {
                        setDeletepopupType("error")
                        SetAlertDeletePopupType("error")
                        console.log(error)
                    })
                }
                const handleRevive = async () => {
                    try {
                        const response = await axiosConfig.post(`/catlog/discount-coupons/${row.id}/revive/`)
                        setpopupType("success")
                        setMessage("Discount revived successfully")
                        GetData()
                    } catch (error) {
                        console.log("Error While Reviving", error)
                    }
                }
                return (
                    <>
                        {!row.is_suspended ?
                            <div className="row" >
                                <div className="table-actions">
                                    <button className="action-btn edit-btn" onClick={HandleEdit}>
                                        <MdOutlineEdit /> Edit
                                    </button>

                                    <button className="action-btn delete-btn" onClick={DeleteAlert}>
                                        <MdDeleteOutline /> Delete
                                    </button>
                                </div>
                            </div>
                            :
                            <>
                                <FaHandHoldingHeart className="dashboard-tabe-data-actions" onClick={handleRevive} />
                            </>
                        }
                        {
                            AlertDeletePopupType === "success" &&
                            <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />
                        }
                    </>
                )

            }
        }
    ]
    return (
        <>
            <div className="child-sidenav">
                <MarketingNavbarComponent />
                <div className="childnav-content">
                    <div className="cat-button">
                        <h5 className="dashboard-subtitle">Discounts</h5>
                        <div className="btn" onClick={handleShow} >
                            + Add New
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 form-group">
                            <input
                                className="form-control"
                                type="date"
                                name="from_date"
                                value={date.from_date}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-3 form-group">
                            <input
                                className="form-control"
                                type="date"
                                name="to_date"
                                value={date.to_date}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-1">
                            <div>
                                <button className="btn btn-primary" style={{ minHeight: '37px' }} onClick={GetData}>Filter</button>
                            </div>
                        </div>
                        <div className="col-5">
                            <div className="input-cat-with-icon">
                                <span className="icon-product"><BiSearch /></span>
                                <input type="text" className="input-control" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-4 input-cat-with-icon">
                        <span className="icon-product"><BiSearch /></span>
                        <input type="text" className="input-control" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />
                    </div> */}
                    <div className="table-responsive marginTop">
                        <DataTable columns={columns} data={Data} pagination paginationTotalRows={totalRows}
                            paginationPerPage={RowPerPage}
                            paginationDefaultPage={currentPage}
                            onChangePage={(page) => setCurrentPage(page)}
                            paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                            onSort={handleSort}
                            paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                            progressComponent={<div className="loader-container">
                                <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                            </div>}
                        />
                    </div>
                    <div>
                        <Modal
                            size="xl"
                            show={show}
                            onHide={handleClose}
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-modal-sizes-title-lg">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {passwordError && (
                                    <div className="alert alert-danger" role="alert">
                                        {passwordError}
                                    </div>
                                )}

                                {
                                    modalTitle === "Edit Discounts" ?
                                        <FormParser key={renderKey} modelObject={MastersModalEdit} formData={formData} formSubmit={formSubmit} error={Error} buttonTitle='Save' /> :
                                        <FormParser modelObject={MastersModal} formSubmit={formSubmit} error={Error} buttonTitle='Save' />
                                }
                            </Modal.Body>
                        </Modal>
                        {popupType !== "" &&
                            <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="" error={message} Message={message} setMessage={setMessage} />
                        }
                        {deletePopupType !== "" &&
                            <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
export { Discounts }